export function dataInRequest(params = {}) {
    return {
        type: '@rateio/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@rateio/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@rateio/FAILED_REQUEST',
    };
}

export function deleteData(id, params) {
    return {
        type: '@rateio/DELETE_DATA',
        payload: { id, params },
    };
}

export function updateData(data, params) {
    return {
        type: '@rateio/UPDATE_DATA',
        payload: { data, params },
    };
}

export function storeData(data, params) {
    return {
        type: '@rateio/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@rateio/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@rateio/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@rateio/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@rateio/RECORD_FILTERING',
        payload: { params },
    };
}

export function stopLoading(params) {
    return {
        type: '@rateio/STOP_LOADING',
        payload: { params }
    }
}
